import { useEffect, useState } from 'react';

export const useDebounce: Function = (initValue: any, delay: number) => {
  const [value, setValue] = useState(initValue);
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [delay, value]);

  return [value, setValue, debouncedValue];
};
